// typescript
import { SubscriptionActions } from 'client/actions/actionTypes'
import {
  SubscriptionSettings,
  SubscriptionSettingsStateInterface,
} from 'client/Interfaces/Subscription/ReduxStateInterfaces'

import { ReducerBuilder } from '../ReducerBuilder'

type payloadType = SubscriptionSettings

const initialState = { loaded: false, settings: {} }

const setSettings = (state: SubscriptionSettingsStateInterface, payload: SubscriptionSettings) => {
  return { loaded: true, settings: payload }
}

const reducer = ReducerBuilder.create<SubscriptionSettingsStateInterface, payloadType>(initialState)
  .mapAction(SubscriptionActions.LOAD_SETTINGS, setSettings)
  .mapAction(SubscriptionActions.UPDATE_SETTINGS, setSettings)
  .build()

export default reducer
